import { ReactElement } from 'react';
import classNames from 'classnames';
import './StaticInput.less';

export type StaticInputProps = {
    className?: string,
    value?: any
}

export const StaticInput = (props: StaticInputProps): ReactElement => {

    return (
        <div className={classNames("x-staticinput", props.className)}>
            {props.value}
        </div>
    )

}
